module.exports = "https://web-assets-production.autolist.com/_next/static/images/crossover-693e76b4f63a3632bbc21c4bb99a523d.jpg";